export const GET_ERRORS = "get:errors";
export const MAX_REACH_ERROR = "max:reach:errors";
export const MAX_REACH_ERROR_UPDATE = "max:reach:errors:update";
export const GLOBAL_SPINNER = "spinner";
